var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.items),function(photo,i){return _c('div',{key:i,staticClass:"col-md-3"},[_c('processed-photo',{attrs:{"item":photo}})],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }